import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudOk = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 78,
	height: 44,
	viewBox: "0 0 78 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M64.25 17H61.2783C59.2097 7.28618 50.5807 0 40.25 0H39.25C28.9193 0 20.2903 7.28618 18.2217 17H14.25C6.79416 17 0.75 23.0442 0.75 30.5C0.75 37.9558 6.79416 44 14.25 44H64.25C71.7058 44 77.75 37.9558 77.75 30.5C77.75 23.0442 71.7058 17 64.25 17ZM37.054 30.8314L29.04 22.7528L31.7627 20.0093L37.054 25.3415L47.8885 14.4214L50.6112 17.165L37.054 30.8314Z",
		fill: "#7F8083"
	})
});
export default SvgCloudOk;
